import React from 'react';
import { TextField,FormGroup,FormControlLabel,Checkbox } from '@mui/material';
import { Paginador } from '../comun/Index';
import ModalPase from './ModalPase';
import ModalPersonas from './ModalPersonas';
import Listado from './Listado';
import './estilos.css'
import axios from 'axios';

class Area extends React.Component{
  render(){
    const {nombre, seleccionar, seleccionado} = this.props;
    return(
      <span 
        className="Area"
        style={{backgroundColor: seleccionado ? '#f77838' : 'lightgrey'}}
        onClick={() => seleccionar()}
      >
        {nombre}
      </span>
    )
  }
}

const getAreas = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/areas/todos/'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.areas)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

const getOficios = function(params){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/oficios/todos/'
    const config = {
      headers:{authorization:sessionStorage.getItem('token')},
      params
    };
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  })
}

const setPersonas = function(datos){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/oficios/todos/personas';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        resolve()
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  })
}

const getURLPase = function(estado_id){
  let recurso = ''
  switch (estado_id) {
    case 1:
      recurso = 'agente/observado';
      break;
    case 2:
      recurso = 'todos/derivado';
      break;
    case 3:
      recurso = 'agente/parcial';
      break;
    case 4:
      recurso = 'agente/finalizado';
      break;
    default:
      break;
  }
  return(recurso);
}

const setPase = function(datos){
  return new Promise((resolve, reject) => {
    console.log(datos)
    const url = localStorage.getItem('apiUrl') + '/pases/' + getURLPase(datos.estado_id);
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) => resolve(res.data))
    .catch((error) => reject(error));
  })
}

const modeloPase = {
  oficio_id:null,
  areaSelec:null,
  estado_id:1,
  observaciones:"",
  estadoSelec:null
}

const modeloPersonas = {
  oficio_id:null,
  personasSelec:[]
}

export default class Mesa extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      loading:false,
      busqueda:"",
      areas:[],
      areasSelec:[],
      oficios:[],
      total:10, 
      limit:20, 
      offset:0,
      filtros:{
        busqueda:null,
        areasSelec:[]
      },
      propio:true,
      datosPase:modeloPase, 
      datosPersonas:modeloPersonas,
      showPase:false,
      showPersonas:false,
      userTipo:null
    }
  }

  componentDidMount(){
    getAreas()
    .then((areas) => {
      const userTipo = sessionStorage.getItem('tipo');
      this.setState({areas,userTipo});
      this.actualizar();
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  actualizar(busquedaP = null, areasSelecP = null, offsetP = null, propioP = null){
    this.setState({loading:true});
    let {busqueda, areasSelec, offset, limit, propio} = this.state;
    const params = {
      busqueda: busquedaP === null ? busqueda : busquedaP,
      offset: offsetP === null ? offset : offsetP,
      propio: propioP === null ? propio : propioP,
      limit
    }
    getOficios(params)
    .then((resp) => {
      this.setState({oficios:resp.oficios, total:resp.total, loading:false});
    })
    .catch((error) => {
      console.log(error);
      this.setState({loading:false});
      alert("Ocurrió un error");
    })
  }

  seleccionarArea(areaId){
    if (!this.state.loading){
      let areasSelec = JSON.parse(JSON.stringify(this.state.areasSelec));
      const pos = areasSelec.indexOf(areaId);
      if (pos === -1){
        areasSelec.push(areaId);
      } else {
        areasSelec.splice(pos, 1);
      }
      this.setState({areasSelec});
      this.actualizar(null, areasSelec)
    }
  }

  busqueda(valor){
      this.setState({busqueda:valor})
      this.actualizar(valor)
  }

  setPropio(valor){
    this.setState({propio:valor})
    this.actualizar(null,null, null, valor)
  }
  
  setOffset(offset){
    if (!this.state.loading){
      this.setState({offset});
      this.actualizar(null, null, offset);
    }
  }

  editar(formulario, campo, valor){
    let datosFormulario = JSON.parse(JSON.stringify(this.state[formulario]));
    datosFormulario[campo] = valor;
    this.setState({[formulario]:datosFormulario});
  }

  realizarPase(oficio_id){
    let datosPase = JSON.parse(JSON.stringify(this.state.datosPase));
    datosPase.oficio_id = oficio_id;
    this.setState({datosPase, showPase:true})
  }

  agregarPersonas(oficio_id){
    let datosPersonas = JSON.parse(JSON.stringify(this.state.datosPersonas));
    datosPersonas.oficio_id = oficio_id;
    this.setState({datosPersonas, showPersonas:true})
  }

  guardarPase(datosPase){
    let datos = {
      area_id: datosPase.areaSelec?.id,
      oficio_id: datosPase.oficio_id,
      estado_id: datosPase.estado_id,
      observaciones:datosPase.observaciones
    }
    if (datosPase.estadoSelec !== null) datos.estado_id = datosPase.estadoSelec.id;
    setPase(datos)
    .then(() => {
      // alert("Pase guardado");
      this.setState({datosPase:modeloPase, showPase:false});
      this.actualizar()
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  guardarPersonas(datos){
    datos.personas = datos.personasSelec.map((persona) => persona.id)
    delete datos.personasSelec;
    setPersonas(datos)
    .then(() => {
      // alert("Personas guardado");
      this.setState({showPersonas:false});
      this.actualizar()
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error")
    })
  }

  render(){
    const {
      busqueda, oficios, areas, areasSelec,
      total, limit, offset, loading,
      datosPase, showPase,propio,
      datosPersonas, showPersonas,userTipo
    } = this.state;
    return(
      <div className="Todo Configuraciones">
        {showPase && 
          <ModalPase
            nuevo={false}
            areas={areas}
            datosPase={datosPase}
            editar={(campo, valor) => this.editar('datosPase', campo, valor)}
            guardar={() => this.guardarPase(datosPase)}
            salir={() => this.setState({datosPase:modeloPase, showPase:false})}
          />
        }
        {showPersonas && 
          <ModalPersonas
            datosPersonas={datosPersonas}
            editar={(campo, valor) => this.editar('datosPersonas', campo, valor)}
            guardar={() => this.guardarPersonas(datosPersonas)}
            salir={() => this.setState({datosPersonas:modeloPersonas, showPersonas:false})}
          />
        }
        <div className="TramitesTodo">
          <h3>Oficios</h3>
        </div>
        <div style={{width:'90%', display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
          <div className="Busqueda">
            <TextField
              size="small"
              style={{textAlign:'center',minWidth:0,margin:'5px 1px'}}
              sx={{backgroundColor:'white', borderRadius:1}}
              label="Busqueda"
              value={busqueda}
              placeholder='Nro, DNI, Apellido...'
              onChange={(e) => this.busqueda(e.target.value)}
              variant="outlined"
            />
          </div>
          {userTipo == 4 &&
            <div style={{display:'flex', flexDirection:'row', alignItems:'flex-end'}}>
              <FormGroup
                style={{flex:1, textAlign:'center', alignItems:'center', justifyContent:'center', display:'flex', overflow:'hidden'}}
              >
                <FormControlLabel control={<Checkbox checked={propio} onChange={(e) => this.setPropio(e.target.checked)}/>} label="Propios" />
              </FormGroup>
            </div>
          }
          {/* <div className="Areas">
            {areas.map((area) => {
              return(
                <Area
                  key={area.id}
                  seleccionar={() => this.seleccionarArea(area.id)}
                  seleccionado={areasSelec.includes(area.id)}
                  nombre={area.nombre}
                />
              )
            })}
          </div> */}
        </div>
        <div style={{display:'flex', flexDirection:'column', width:'85%', justifyContent:'center', alignItems:'center'}}>
          {loading && 
            <h3>Cargando...</h3>
          }
          {(!loading && oficios?.length > 0) &&
            <Listado
              oficios={oficios}
              mesa={false}
              realizarPase={(oficio_id) => this.realizarPase(oficio_id)}
              agregarPersonas={(oficio_id) => this.agregarPersonas(oficio_id)}
              establecerRecordatorio={(oficio_id)=>alert("Establece rec.")}
              subir={(oficio_id) => alert("Subir archivo")}
              descargar={(oficio_id) => alert("Descargar archivo")}
            />
          }
          {oficios?.length > 0 &&
            <Paginador
              total={total}
              limit={limit}
              offset={offset}
              setOffset={(offset) => {window.scrollTo(0,0);this.setOffset(offset)}}
            />
          }
        </div>
      </div>
    )
  }
}